<template>
  <cms-experiment v-if="popUp" :content="popUp" />
</template>

<script lang="ts" setup>
const { $gtm } = useNuxtApp()
const { getPopUps } = useCms()
const { open, popUp } = usePopUp()
const { decide, decisions } = useOptimizely()
const router = useRouter()

const getVariantKey = (key: string): string => (key.match(/\d+-(.+)/) || [])[1] || ''
const data = await getPopUps()
const content = data?.items?.[0]
const flagKey = content?.experienceId?.match(/optimizely_experience_(.+)$/)?.[1] || ''

if (content && flagKey) {
  await decide(flagKey, getOptimizelyCmsCmabDecideOptions(content.experienceType, content.attribute_keys))

  const chosenTargets = content.variants.find(
    ({ variantId }) => getVariantKey(variantId) === decisions.value.get(flagKey)?.variationKey
  )?.targets || []
  const hasVisiblePopup = chosenTargets.length > 0 || content.baselines?.length > 0

  if (hasVisiblePopup) {
    const { name, minimizedTitle } = content.baselines?.[0] || {}
    const isNewsLetterPopup = name?.toLowerCase()?.includes('newsletter')

    const category = isNewsLetterPopup ? 'Newsletter' : 'Account'
    const action = isNewsLetterPopup ? minimizedTitle : 'Registration'

    $gtm.push('popUp.onImpression', category, action)
    open(data.items, category, action)
  }
}

const navCount = useState<number>('popupNavigations', () => 0)

let destroyFn

if (popUp.value) {
  destroyFn = router.afterEach((to, from) => {
    if (to.fullPath === from.fullPath) return
    navCount.value++
  })
}

onMounted(() => localStorage.removeItem('dismissedPopups')) // temporary code, removes old key to clean LS
onBeforeUnmount(() => destroyFn?.())
</script>
